import TestingSVGLabel from 'assets/svg/DEMO.svg?react'

import { DemoBadgeWrapper } from './styled'

const DEMO_BADGE_TEST_ID = 'icon_demo'

/**
 * Overlay badge flagging an organization used for internal testing (Demo).
 * Renders nothing when the organization is not a demo one.
 * Must be placed inside a `position: relative` container to overlay a logo.
 */
function OrganizationDemoBadge({ forInternalTesting, className, dataTestId = DEMO_BADGE_TEST_ID }) {
  if (!forInternalTesting) return null

  return (
    <DemoBadgeWrapper className={className}>
      <TestingSVGLabel data-testid={dataTestId} />
    </DemoBadgeWrapper>
  )
}

export default OrganizationDemoBadge
